export enum EnforcementType {
    ENABLED = 'Enabled',
    DISABLED = 'Disabled',
    AUDIT = 'Audit',
}
